import { journeyAction, } from './base';

import { JourneyActionAgent as JourneyActionAgentBase, } from 'atlas-shared';

export const JourneyActionAgent = journeyAction({
  ...JourneyActionAgentBase,
  icon: 'User',
});
